var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"button-form",attrs:{"loading":_vm.loading,"tag":"button","size":_vm.size,"submit":true}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }